<script lang="ts">
  import { go } from "../../lib/router.svelte";
</script>

<section class="max-w-md mx-auto px-6 py-24 text-center">
  <h1 class="text-3xl font-bold text-emerald-400">Payment successful</h1>
  <p class="mt-4 text-slate-400">
    Your plan is being activated. It may take a moment for the subscription to
    sync — refresh your account if needed.
  </p>
  <a
    href="/account"
    onclick={(e) => go(e, "/account")}
    class="mt-8 inline-block px-5 py-3 rounded-md bg-indigo-500 hover:bg-indigo-400 text-white"
  >
    Go to account
  </a>
</section>
